import { createSlice } from "@reduxjs/toolkit";

// Import types
import { MediaTypes } from "src/types/check-devices";
import { v4 } from "uuid";

type MediaState = {
  // Selected Devices
  cameraDeviceId: string;
  inputDeviceId: string;
  outputDeviceId: string;
  availableDevices: Array<any>;

  // Variables
  localMediaId: null | string;
};

const initialState: MediaState = {
  // Devices & Media
  cameraDeviceId: "default",
  inputDeviceId: "default",
  outputDeviceId: "default",
  availableDevices: [],

  // Variables
  localMediaId: null,
};

const contextSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    // Media & Devices
    setMediaStream: (state) => {
      state.localMediaId = v4();
    },

    updateDevices: (state, { payload: { type, deviceId } }) => {
      if (type === MediaTypes.AUDIO) state.outputDeviceId = deviceId;
      if (type === MediaTypes.MIC) state.inputDeviceId = deviceId;
      if (type === MediaTypes.CAM) state.cameraDeviceId = deviceId;
    },

    updateMultipleDevices: (state, { payload }: { payload: Array<{ type: string; deviceId: string }> }) => {
      payload.forEach((d) => {
        const { type, deviceId } = d;

        if (type === MediaTypes.AUDIO) state.outputDeviceId = deviceId;
        if (type === MediaTypes.MIC) state.inputDeviceId = deviceId;
        if (type === MediaTypes.CAM) state.cameraDeviceId = deviceId;
      });
    },
    updateAvailableDevices: (state, { payload }: { payload: Array<any> }) => {
      state.availableDevices = payload;
    },
  },
});

export const {
  // Media Events
  setMediaStream,
  // stopLocalMedia,

  // Device Event
  updateDevices,
  updateMultipleDevices,
  updateAvailableDevices,
} = contextSlice.actions;
export default contextSlice.reducer;
